import { useTheme } from './theme';

export const useFontStyles = () => {
  const theme = useTheme();
  return `
    .${theme.fonts.classNames.pageTitle} {
      font-family: 'Noto Sans Hebrew';
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.fonts.fontSizes.fontSize22}px;
      line-height: 33px;
      color: var(--color-new-blue);
    }

    .${theme.fonts.classNames.mobilePageTitle} {
      font-family: 'Noto Sans Hebrew';
      font-style: normal;
      font-weight: 700;
      font-size: ${theme.fonts.fontSizes.fontSize28}px;
      line-height: 33px;
      color: var(--white);
    }

    .${theme.fonts.classNames.subPageTitle} {
      font-family: 'Noto Sans Hebrew';
      font-style: normal;
      font-weight: 400;
      font-size: ${theme.fonts.fontSizes.fontSize19}px;
      line-height: 20px;
      color: var(--color-new-blue);
    }

    .${theme.fonts.classNames.mobileSubPageTitle} {
      font-family: 'Noto Sans Hebrew';
      font-style: normal;
      font-weight: 400;
      font-size: ${theme.fonts.fontSizes.fontSize21}px;
      line-height: 20px;
      color: var(--white);
    }

    .${theme.fonts.classNames.comment} {
      font-family: 'Noto Sans Hebrew';
      font-size: ${theme.fonts.fontSizes.fontSize14}px;
      font-weight: 400;
      color: var(--color-commentGrey);
    }

    .${theme.fonts.classNames.cardTitle} {
      font-family: 'Noto Sans Hebrew';
      font-size: ${theme.fonts.fontSizes.fontSize18}px;
      font-weight: 700;
      color: var(--color-new-blue);
    }

    .${theme.fonts.classNames.cardSubtitle} {
      font-family: 'Noto Sans Hebrew';
      font-size: ${theme.fonts.fontSizes.fontSize14}px;
      font-weight: 400;
      color: var(--new-blue);
    }

    .${theme.fonts.classNames.subPageTitleWidth} {
      font-family: 'Noto Sans Hebrew';
      font-style: normal;
      font-weight: 800;
      font-size: ${theme.fonts.fontSizes.fontSize24}px;
      line-height: 20px;
      color: var(--color-new-blue);
    }

    .${theme.fonts.classNames.button} {
      font-family: 'Noto Sans Hebrew';
      font-size: ${theme.fonts.fontSizes.fontSize16}px;
      font-weight: 500;
      color: var(--white);
      white-space: normal;
    }

    .${theme.fonts.classNames.mainPageUserName} {
      font-family: 'Noto Sans Hebrew';
      font-style: normal;
      font-weight: 400;
      font-size: ${theme.fonts.fontSizes.fontSize18}px;
      line-height: 20px;
      color: var(--white);
    }

    .${theme.fonts.classNames.mainPageTitle} {
      font-family: 'Noto Sans Hebrew';
      font-weight: 700;
      font-size: ${theme.fonts.fontSizes.fontSize24}px;
      color: var(--white);
    }

    .${theme.fonts.classNames.subPageTitleWhite} {
      text-align: center;
      font-family: 'Noto Sans Hebrew';
      font-style: normal;
      font-weight: 400;
      font-size: ${theme.fonts.fontSizes.fontSize16}px;
      line-height: 20px;
      letter-spacing: 0.1px;
      color: var(--silverGray);
    }
  `;
};
